import { gql } from '@apollo/client';

const CheckoutTrackingQuery = gql`
  query CheckoutTrackingQuery($language: Language, $testmode: Boolean) {
    user(language: $language, testmode: $testmode) {
      id
      isAuthenticated
      cart {
        id
        type
        items {
          id
          product {
            id
            title
            masterSku
            sku
            brand
            category
          }
          totalPrice
          amount
        }
        paymentMethod {
          id
          method
        }
        totals {
          id
          valueInEuro
        }
        billingAddress {
          id
          countryCode
        }
      }
    }
  }
`;

export default CheckoutTrackingQuery;
